// utils/errorUtils.ts
export interface RTKErrorResponse {
  status: string;
  originalStatus?: number;
  data?: any;
  error?: string;
  message?: string;
}

export interface ErrorHandlingOptions {
  defaultMessage?: string;
}

export const handleApiError = (
  error: any, 
  options: ErrorHandlingOptions = {}
): string => {
  const {
    defaultMessage = "Failed to load data"
  } = options;
  
  const typedError = error as RTKErrorResponse;
  let errorMessage = defaultMessage;
  
  if (typedError?.originalStatus === 404) {
    // Handle 404 specifically - extract message from data field
    if (typeof typedError.data === 'string') {
      errorMessage = typedError.data;
    } else if (typedError.data?.message) {
      errorMessage = typedError.data.message;
    } else {
      errorMessage = "No data found for the selected criteria";
    }
  } else if (typedError?.data?.message) {
    errorMessage = typedError.data.message;
  } else if (typedError?.error) {
    errorMessage = typedError.error;
  } else if (typedError?.message) {
    errorMessage = typedError.message;
  }
  
  return errorMessage;
};